import React from "react";
import { exact, PropTypes } from "prop-types";
import styles from "./SportsmanList.module.styl";
import SportsmanCard from "./SportsmanCard/SportsmanCard";

export default function SportsmanList({ sportsmans }) {
    if (!sportsmans || sportsmans.length === 0)
        return (
            <div className={styles.notFound}>
                По данным параметрам не найдено ни одного спортсмена. Пожалуйста, измените параметры
                поиска
            </div>
        );

    return (
        <div>
            <div className={styles.title}>
                <div className={styles.sportName}>Спортсмен</div>
                <div className={styles.rfRating}>Место в рейтинге РФ</div>
                <div className={styles.regionRating}>Место в рейтинге внутри субъекта РФ</div>
                <div className={styles.schoolRating}>Место в рейтинге организации</div>
                <div className={styles.rating}>Сред. значение по сессии тестирования</div>
            </div>
            <div>
                {sportsmans?.map((item, i) => (
                    <SportsmanCard key={item.id} sportsman={item} index={i + 1} />
                )) ?? []}
            </div>
        </div>
    );
}

const sportsmanType = exact({
    id: PropTypes.number.isRequired,
    sex: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    birthDate: PropTypes.string,
    sportType: PropTypes.string.isRequired,
    trainingLevel: PropTypes.string.isRequired,
    regionPosition: PropTypes.number.isRequired,
    rfPosition: PropTypes.number.isRequired,
    schoolPosition: PropTypes.number.isRequired,
    rating: PropTypes.number.isRequired,
}).isRequired;

SportsmanList.propTypes = {
    sportsmans: PropTypes.arrayOf(sportsmanType).isRequired,
};
